import React, { useEffect, useState, type FC, useCallback } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import BaseShoppingCart from '@/registration/component/Register/ShoppingCart';
import LayoutFooter from '@/registration/component/Register/Layout/Footer';
import { UiButton, UiHStack, UiIconCaretLeft, UiIconCaretRight, UiStack, UiText } from '@/lib/ui';
import { useRegisterSteps } from '@/registration/hook/useRegisterSteps';
import { useCartQuery } from '@/registration/hook/useCartQuery';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { useQueryClient } from '@tanstack/react-query';
import { registrationQueryKey } from '@/api/registration';
import { useRegistrationQuery } from '@/registration/hook/useRegistrationQuery';
import InfoBox from '@/registration/component/InfoBox';
import { useNavigate } from 'react-router-dom';
import { useTenantRoute } from '@/account/hook/useTenantRoute';
import { generatePageUrl } from '@/app/pages';
import RemindToAddTickets from '@/registration/component/Register/RemindToAddTickets';
import { useRegisterUpsellSteps } from '@/registration/hook/useRegisterUpsellSteps';
import BaseThemeButton from '@/base/ThemeButton';
import BrandFooter from '@/registration/component/Register/Layout/BrandFooter';

interface ShoppingCartProps {
  isUpsell?: boolean
}

const ShoppingCart: FC<ShoppingCartProps> = ({ isUpsell }) => {
  const { eventId } = useRegisterRoute();
  const cartQuery = useCartQuery(eventId);
  const queryClient = useQueryClient();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const registrationQuery = useRegistrationQuery(eventId);
  const navigate = useNavigate();
  const { tenant } = useTenantRoute();
  const { toNextStep: defaultToNextStep, toPreviousStep: defaultToPreviousStep } = useRegisterSteps();
  const { toNextStep: upsellToNextStep, toPreviousStep: upsellToPreviousStep } = useRegisterUpsellSteps();

  const toNextStep = isUpsell ? upsellToNextStep : defaultToNextStep;
  const toPreviousStep = isUpsell ? upsellToPreviousStep : defaultToPreviousStep;

  const handleNext = async () => {
    if (cartQuery?.data?.totalAmount !== undefined && cartQuery.data.totalAmount <= 0) {
      await queryClient.invalidateQueries({ queryKey: [registrationQueryKey] });
    }
    setSubmitting(true);
  };

  useEffect(() => {
    if (submitting && registrationQuery.isSuccess) {
      toNextStep();
    }
  }, [registrationQuery.isSuccess, submitting, toNextStep]);

  return (
    <RegisterLayout>
      <BaseTransitionSlideLeft>
        <QueryContainer query={cartQuery} errorMessage="Failed to load the shopping cart.">
          {(shoppingCart) => {
            return (
              <UiStack flexGrow={1} spacing={8}>
                {/*<UiStack pb={4}>*/}
                {/*  <UiText variant={'h6'}>Shopping cart</UiText>*/}
                {/*</UiStack>*/}
                <InfoBox
                  title={'Shopping cart'}
                />
                <UiStack spacing={4}>
                  <RemindToAddTickets isUpsell={isUpsell} />
                  <BaseShoppingCart />
                </UiStack>
              </UiStack>
            );
          }}
        </QueryContainer>
      </BaseTransitionSlideLeft>
      <UiStack height={96} />
      <LayoutFooter>
        <UiHStack justifyContent={'space-between'} flexGrow={1}>
          {/*<UiButton*/}
          {/*  size={'lg'}*/}
          {/*  colorScheme={'primary'}*/}
          {/*  onClick={toPreviousStep}*/}
          {/*  variant={'ghost'}*/}
          {/*  fontSize={'lg'}*/}
          {/*  leftIcon={(*/}
          {/*    <UiIconCaretLeft color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
          {/*  )}*/}
          {/*>*/}
          {/*  Previous*/}
          {/*</UiButton>*/}
          {/*<UiButton*/}
          {/*  size={'lg'}*/}
          {/*  colorScheme={'primary'}*/}
          {/*  onClick={handleNext}*/}
          {/*  isDisabled={(cartQuery?.data?.cartItems?.length ?? 0) === 0}*/}
          {/*  variant={'ghost'}*/}
          {/*  fontSize={'lg'}*/}
          {/*  rightIcon={(*/}
          {/*    <UiIconCaretRight color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
          {/*  )}*/}
          {/*>*/}
          {/*  Next*/}
          {/*</UiButton>*/}

          <BaseThemeButton
            theme={'gray'}
            onClick={toPreviousStep}
            leftIcon={(
              <UiIconCaretLeft color={'primary.800'} size={'lg'} weight={'bold'}/>
            )}
          >
            Prev
          </BaseThemeButton>
          <BrandFooter/>
          <BaseThemeButton
            theme={'primary'}
            onClick={handleNext}
            isDisabled={(cartQuery?.data?.cartItems?.length ?? 0) === 0}
            rightIcon={(
              <UiIconCaretRight color={'primary.800'} size={'lg'} weight={'bold'}/>
            )}
          >
            Next
          </BaseThemeButton>
        </UiHStack>
      </LayoutFooter>
    </RegisterLayout>
  );
};

export default ShoppingCart;
